var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFilterStore } from '../store/filterStore';
import { useFilterConfigStore } from '../store/filterConfigurationStore';
import { useAlertStore } from '../store/alerts';
import { deriveUrl } from '../parsing/deriveConfig';
import { parseSiteMetadata } from '../parsing/parse';
import { reassociateFilter } from '../utils/restoreFilter';
import { Editor } from '@monaco-editor/react';
import { Delete, Download, Upload } from '@mui/icons-material';
import { Box, Button, Container, FormControlLabel, Switch, Tab, Tabs, Typography, } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FLAG_NAMES, useFeatureFlagStore } from '../components/FeatureFlagged';
import { allStorageKeys, clearAllState, downloadFile, localState, uploadState, } from '../utils/file';
var useStorageData = function () {
    var _a = useState({}), data = _a[0], setData = _a[1];
    var reload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var state;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, localState()];
                case 1:
                    state = _a.sent();
                    setData(state);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        reload();
    }, []);
    return { data: data, reload: reload };
};
var FilterStoreTabs = function (_a) {
    var _b;
    var data = _a.data, filterStoreTab = _a.filterStoreTab, setFilterStoreTab = _a.setFilterStoreTab;
    var filterStore = data['filter-store'];
    if (!((_b = filterStore === null || filterStore === void 0 ? void 0 : filterStore.state) === null || _b === void 0 ? void 0 : _b.filters))
        return null;
    return (_jsxs(Tabs, __assign({ value: filterStoreTab, onChange: function (_, newValue) { return setFilterStoreTab(newValue); } }, { children: [_jsx(Tab, { value: "everything", label: "Everything" }), Object.entries(filterStore.state.filters).map(function (_a) {
                var key = _a[0], filter = _a[1];
                return (_jsx(Tab, { value: key, label: filter.name }, key));
            })] })));
};
var renderContent = function (tab, filterStoreTab, data) {
    var _a, _b;
    var value = data[tab];
    if (value === undefined || value === null)
        return 'No data found for this tab';
    var content = value;
    if (tab === 'filter-store' && filterStoreTab !== 'everything') {
        var state = content.state;
        content = (_a = state === null || state === void 0 ? void 0 : state.filters) === null || _a === void 0 ? void 0 : _a[filterStoreTab];
    }
    else if (tab === 'filter-configuration-store' &&
        filterStoreTab !== 'everything') {
        var state = content.state;
        content = (_b = state === null || state === void 0 ? void 0 : state.filterConfigurations) === null || _b === void 0 ? void 0 : _b[filterStoreTab];
    }
    return JSON.stringify(content, null, 2);
};
var isJson = function (value) {
    return typeof value === 'object' && value !== null;
};
export var DebugPage = function () {
    useNavigate();
    var _a = useState('filter-store'), tab = _a[0], setTab = _a[1];
    var _b = useState('everything'), filterStoreTab = _b[0], setFilterStoreTab = _b[1];
    var _c = useStorageData(), data = _c.data, reload = _c.reload;
    var _d = useFilterStore(), filters = _d.filters, updateFilter = _d.updateFilter;
    var _e = useFilterConfigStore(), filterConfigurations = _e.filterConfigurations, setFilterConfiguration = _e.setFilterConfiguration;
    var addAlert = useAlertStore().addAlert;
    var _f = useState(false), reassociating = _f[0], setReassociating = _f[1];
    var selectedFilter = filters[filterStoreTab];
    var forceReassociation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var metadata, source, restored, error_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!selectedFilter)
                        return [2 /*return*/];
                    setReassociating(true);
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 4, 5, 6]);
                    metadata = parseSiteMetadata(selectedFilter.rs2f).metadata;
                    source = (_b = (_a = selectedFilter.source) !== null && _a !== void 0 ? _a : deriveUrl(selectedFilter)) !== null && _b !== void 0 ? _b : (_c = window
                        .prompt('Enter the original source URL for this filter:')) === null || _c === void 0 ? void 0 : _c.trim();
                    if (!source)
                        return [2 /*return*/];
                    return [4 /*yield*/, reassociateFilter(selectedFilter, filterConfigurations[selectedFilter.id], source, (_d = selectedFilter.commit) !== null && _d !== void 0 ? _d : metadata === null || metadata === void 0 ? void 0 : metadata.commit, (_e = selectedFilter.revisionUrl) !== null && _e !== void 0 ? _e : metadata === null || metadata === void 0 ? void 0 : metadata.revisionUrl)];
                case 2:
                    restored = _f.sent();
                    updateFilter(restored.filter);
                    setFilterConfiguration(restored.filter.id, restored.config);
                    return [4 /*yield*/, reload()];
                case 3:
                    _f.sent();
                    addAlert({
                        children: "Re-associated \"".concat(restored.filter.name, "\" with its source"),
                        severity: 'success',
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _f.sent();
                    addAlert({ children: error_1.message, severity: 'error' });
                    return [3 /*break*/, 6];
                case 5:
                    setReassociating(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var _g = useFeatureFlagStore(), checkFeatureFlag = _g.checkFeatureFlag, setFeatureFlag = _g.setFeatureFlag;
    return (_jsxs(Container, __assign({ maxWidth: "lg" }, { children: [_jsx(Box, { children: FLAG_NAMES.map(function (flag) { return (_jsx(FormControlLabel, { control: _jsx(Switch, { checked: checkFeatureFlag(flag), onChange: function (e) {
                            setFeatureFlag(flag, e.target.checked);
                        } }), label: _jsxs(Typography, __assign({ color: "text.secondary", fontSize: "24px" }, { children: [flag, " feature flag"] })) }, flag)); }) }), _jsxs(Box, __assign({ sx: {
                    mt: 5,
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 2,
                } }, { children: [_jsxs(Button, __assign({ sx: { width: '250px' }, variant: "outlined", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var state, fileName, file;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, localState()];
                                    case 1:
                                        state = _a.sent();
                                        fileName = "filterscape_state_".concat(Date.now()
                                            .toString()
                                            .replaceAll('/', '-'), ".json");
                                        file = new File([JSON.stringify(state)], fileName, { type: 'text/plain' });
                                        downloadFile(file);
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: [_jsx(Download, { sx: { fontSize: '20px' } }), "Download Local State"] })), _jsxs(Button, __assign({ sx: { width: '250px' }, variant: "outlined", component: "label" }, { children: [_jsx(Upload, { sx: { fontSize: '20px' } }), "Upload Local State", _jsx("input", { type: "file", hidden: true, accept: ".json", onChange: function (e) {
                                    var _a;
                                    var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                    if (!file)
                                        return;
                                    var reader = new FileReader();
                                    reader.onload = function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var content, state;
                                        var _a;
                                        return __generator(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    content = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
                                                    state = JSON.parse(content);
                                                    return [4 /*yield*/, uploadState(state)];
                                                case 1:
                                                    _b.sent();
                                                    window.location.href = "".concat(window.location.protocol, "://").concat(window.location.host);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); };
                                    reader.readAsText(file);
                                } })] })), _jsxs(Button, __assign({ sx: { width: '250px', color: 'red' }, variant: "outlined", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, clearAllState()];
                                    case 1:
                                        _a.sent();
                                        window.location.href = "".concat(window.location.protocol, "://").concat(window.location.host);
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: [_jsx(Delete, { sx: { fontSize: '20px' } }), "Delete All Stored Data"] }))] })), _jsxs(Box, { children: [_jsx(Tabs, __assign({ value: tab, onChange: function (_, newValue) { return setTab(newValue); } }, { children: allStorageKeys.map(function (key) { return (_jsx(Tab, { value: key, label: key }, key)); }) })), (tab === 'filter-store' ||
                        tab === 'filter-configuration-store') && (_jsx(FilterStoreTabs, { data: data, filterStoreTab: filterStoreTab, setFilterStoreTab: setFilterStoreTab })), (tab === 'filter-store' ||
                        tab === 'filter-configuration-store') &&
                        selectedFilter && (_jsx(Button, __assign({ disabled: reassociating, onClick: forceReassociation }, { children: reassociating
                            ? 'Re-associating…'
                            : 'Force re-association' }))), _jsx(Editor, { height: "70vh", language: isJson(data[tab]) ? 'json' : 'text', theme: "vs-dark", options: { minimap: { enabled: false }, readOnly: true }, value: renderContent(tab, filterStoreTab, data) })] })] })));
};
